import { createFileRoute, Navigate, Outlet } from '@tanstack/react-router'

import { useIsAdmin } from '@/auth/isAdmin';

export const Route = createFileRoute('/dashboard/_authenticated/admin')({
  component: RouteComponent,
  staticData: {
    breadcrumb: ['Admin']
  }
})

function RouteComponent() {
  const isAdmin = useIsAdmin();

  if (!isAdmin) {
    return <Navigate to="/dashboard" />;
  }

  return <Outlet />;
}
